import { ChartAdapter, ChartType } from "./types";

const adapterRegistry = new Map<ChartType, ChartAdapter<any>>();

export function registerChartAdapter<TType extends ChartType>(
  adapter: ChartAdapter<TType>
) {
  if (adapterRegistry.has(adapter.type)) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(
        `[CompsChart] 图表类型 "${adapter.type}" 已注册，将覆盖现有适配器`
      );
    }
  }

  adapterRegistry.set(adapter.type, adapter as ChartAdapter<any>);
}

export function getChartAdapter<TType extends ChartType>(
  type: TType
): ChartAdapter<TType> {
  const adapter = adapterRegistry.get(type);

  if (!adapter) {
    throw new Error(`[CompsChart] 未找到图表类型 "${type}" 的适配器`);
  }

  return adapter as ChartAdapter<TType>;
}

export function isChartTypeRegistered(type: ChartType): boolean {
  return adapterRegistry.has(type);
}

export function listChartTypes(): ChartType[] {
  return Array.from(adapterRegistry.keys());
}


